import { Injectable } from '@angular/core'
import { HttpService, LibEntry, Organization } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { Certificate } from '../certification/service/certification.service'

type CriteriaValue = string | string[]

export interface PlatingMaterial {
    id?: string
    new?: boolean
    organizationId?: string
    organization?: Organization
    vendorCode: string
    vendorDescription: string
    vendorMaterialFamily?: LibEntry
    materialFamily?: LibEntry
    material?: LibEntry
    rawMaterialProvenance?: LibEntry
    countryOfOrigin?: LibEntry
    karats?: number
    saltSupplier?: LibEntry
    certificationTypes?: LibEntry[]
    validationStatus?: string
    rejectionReason?: string
    certification?: boolean
    uploadedCertifications?: Certificate[]
    isAllCertificationsUploaded?: boolean
    missingMandatoryCertifications?: LibEntry[]
    // only for front end
    supplier?: LibEntry
}

@Injectable()
export class PlatingMaterialService {
    private baseUrl = '/component-mapping/plating-materials'

    constructor(private http: HttpService) {
        //
    }

    public getAll(organizationId?: string, criteria?: Map<string, CriteriaValue>): Observable<PlatingMaterial[]> {
        const q = new URLSearchParams()
        ;(criteria || new Map()).forEach((v, k) => {
            q.append(k, Array.isArray(v) ? v.join(',') : v)
        })

        const url = this.baseUrl + (organizationId ? '/' + organizationId : '')
        return this.http.get<PlatingMaterial[]>(url + '?' + q.toString())
    }

    public createPlatingMaterials(data: PlatingMaterial[]): Observable<void> {
        return this.http.post<void>(this.baseUrl, { data })
    }

    public updatePlatingMaterials(data: PlatingMaterial[]): Observable<void> {
        return this.http.put<void>(this.baseUrl, { data })
    }
}
